// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3277":"3550c681","6702":"0f960e8d"}[chunkId] + ".chunk.css";
};